if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
            // Registration was successful
            // console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }, function(err) {
            // registration failed :(
            // console.log('ServiceWorker registration failed: ', err);
        });
    });
}

$(document).ready(function () {

    function showPwaAdverts(){
        // show all advert with modal
        $('.pwa_install_wrap').show();

        // hide pwa modal for 1 day if dismissed earlier
        if (Cookies.get('pwa_install_modal_dismiss')) {
            $('.pwa_install_modal').hide();
        }
    }
    // PWA IPHONE modal
    $('.appstore_download_modal').click(function () {
        Swal.fire({
            html: 'Ciesz się rezerwacjami Zjedz.my na swoim iPhonie.<br/><br/>Naciśnij <img src="/images/app/aths.png"> , następnie <span class="btn btn-light ml-1">Do ekranu początk.<i class="far fa-plus-square ml-2"></i></span>',
        });
    });


    // Progressive Web App Install Prompt
    let pwaInstallDeferredPrompt; // Allows to show the install prompt

    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        pwaInstallDeferredPrompt = e;
        showPwaAdverts();
    });

    // hack to show on iOS (which not trigger 'beforeinstallprompt')
    if(/iPhone|iPad|iPod/i.test(navigator.userAgent) ) {
        showPwaAdverts();
    }

    $('.pwa_install_wrap .pwa_install_trigger').click(function () {
        if(pwaInstallDeferredPrompt) {
            // Show the prompt
            pwaInstallDeferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            pwaInstallDeferredPrompt.userChoice
                .then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        // PWA setup accepted
                        $('.pwa_install_wrap').hide();
                    } else {
                        // PWA setup rejected
                    }
                    pwaInstallDeferredPrompt = null;
                });
        }
        // iOS case
        else {
            Swal.fire({
                html: 'Ciesz się rezerwacjami Zjedz.my na swoim iPhonie.<br/><br/>Naciśnij <img src="/images/app/aths.png"> , następnie <span class="btn btn-light ml-1">Do ekranu początk.<i class="far fa-plus-square ml-2"></i></span>',
            });
        }
    });

    // hide all pwa advert and modals if installed
    if((window.navigator.standalone == true) || (window.matchMedia('(display-mode: standalone)').matches)){
        $('.pwa_install_wrap').hide();
    }

    // dismiss pwa modal trigger
    $('.pwa_install_modal_dismiss').click(function(){
        Cookies.set('pwa_install_modal_dismiss', 'true', { expires: 1 })
    });
});